import { GLProgram } from "../program.js";
export class Blit extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var vertex_source = templates.get('photoshop/GL/shaders/blit/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/blit/fragment.glsl');
        var result = new Blit(gl, vertex_source, fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        return result;
    }

}